import { render, staticRenderFns } from "./StudentTaskList.vue?vue&type=template&id=4a37c891&"
import script from "./StudentTaskList.vue?vue&type=script&lang=js&"
export * from "./StudentTaskList.vue?vue&type=script&lang=js&"
import style0 from "./StudentTaskList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports